import { useQuery } from '@tanstack/react-query'
import {
  type MyProfile,
  myProfilePath,
  myProfileSchema,
  viewerIdentityOf,
} from '../../camel/config/myProfile'
import { useCamelQuery } from '../camelQuery'
import type { CamelQueryOptions } from '../types'

export const useViewerIdentity = () =>
  useQuery({
    ...useCamelQuery(myProfilePath(), myProfileSchema),
    select: viewerIdentityOf,
    retry: false,
  })

export const useViewerProfile = (options?: CamelQueryOptions<MyProfile>) =>
  useQuery({
    ...useCamelQuery(myProfilePath(), myProfileSchema),
    retry: false,
    ...options,
  })
